module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/visa-payment-card-e00156f8118f682e077224a6a61748b4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/visa-payment-card.svg
// module id = cmbV
// module chunks = 24